// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { MultilingualUrl } from "./MultilingualUrl";
import {
  MultilingualUrlFromJSON,
  MultilingualUrlFromJSONTyped,
  MultilingualUrlToJSON,
  MultilingualUrlToJSONTyped,
} from "./MultilingualUrl";
import type { MultilingualStringWithLink } from "./MultilingualStringWithLink";
import {
  MultilingualStringWithLinkFromJSON,
  MultilingualStringWithLinkFromJSONTyped,
  MultilingualStringWithLinkToJSON,
  MultilingualStringWithLinkToJSONTyped,
} from "./MultilingualStringWithLink";
import type { MultilingualString } from "./MultilingualString";
import {
  MultilingualStringFromJSON,
  MultilingualStringFromJSONTyped,
  MultilingualStringToJSON,
  MultilingualStringToJSONTyped,
} from "./MultilingualString";

/**
 *
 * @export
 * @interface OnlineLink
 */
export interface OnlineLink {
  /**
   *
   */
  protocol: string;
  /**
   *
   */
  urlObject: MultilingualUrl;
  /**
   *
   */
  nameObject?: MultilingualString | null;
  /**
   *
   */
  descriptionObject?: MultilingualStringWithLink | null;
}

/**
 * Check if a given object implements the OnlineLink interface.
 */
export function instanceOfOnlineLink(value: object): value is OnlineLink {
  if (!("protocol" in value) || value["protocol"] === undefined) return false;
  if (!("urlObject" in value) || value["urlObject"] === undefined) return false;
  return true;
}

export function OnlineLinkFromJSON(json: any): OnlineLink {
  return OnlineLinkFromJSONTyped(json, false);
}

export function OnlineLinkFromJSONTyped(json: any, ignoreDiscriminator: boolean): OnlineLink {
  if (json == null) {
    return json;
  }
  return {
    protocol: json["protocol"],
    urlObject: MultilingualUrlFromJSON(json["urlObject"]),
    nameObject:
      json["nameObject"] === undefined
        ? undefined
        : json["nameObject"] === null
        ? null
        : MultilingualStringFromJSON(json["nameObject"]),
    descriptionObject:
      json["descriptionObject"] === undefined
        ? undefined
        : json["descriptionObject"] === null
        ? null
        : MultilingualStringWithLinkFromJSON(json["descriptionObject"]),
  };
}

export function OnlineLinkToJSON(json: any): OnlineLink {
  return OnlineLinkToJSONTyped(json, false);
}

export function OnlineLinkToJSONTyped(
  value?: OnlineLink | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    protocol: value["protocol"],
    urlObject: MultilingualUrlToJSON(value["urlObject"]),
    nameObject: MultilingualStringToJSON(value["nameObject"]),
    descriptionObject: MultilingualStringWithLinkToJSON(value["descriptionObject"]),
  };
}
